// Vendors
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const focusableTags = ['INPUT', 'SELECT', 'TEXTAREA', 'TEXT', 'BUTTON', 'A'];

const isFocusable = el =>
  focusableTags.includes(el.tagName) || el.tabIndex >= 0;

const Label = ({ id, name, label, className, children }) => (
  <label
    className={classNames('input-label', className)}
    htmlFor={id || name}
    onMouseDown={e => {
      /*
       This fixes a common browser behavior: when a user clicks a <label> or any element associated
       with a radio input, the browser will scroll the radio button into view if it is outside the viewport.
       */
      if (!isFocusable(e.target)) {
        e.preventDefault();
      }
    }}
  >
    {label}
    {children}
  </label>
);

Label.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string.isRequired,
  label: PropTypes.oneOfType([PropTypes.element, PropTypes.string]).isRequired,
  children: PropTypes.node,
};

Label.defaultProps = {
  name: '',
  label: '',
};

export default Label;
